'use client';

import { usePathname } from 'next/navigation';
import ToneHuntBanner from '@/components/ui/ToneHuntBanner/ToneHuntBanner';
import OfficialPluginBanner from '@/components/ui/OfficialPluginBanner/OfficialPluginBanner';

// Decided here rather than in the layout: that layout is shared with /signin, so
// a soft nav into sign-in leaves the server-rendered banners in place.
export default function PromoBanners() {
  const pathname = usePathname() || '';
  if (pathname.startsWith('/signin') || pathname.includes('/api/v1/select')) return null;

  return (
    <div className="divide-y divide-zinc-700">
      <ToneHuntBanner />
      {!pathname.startsWith('/plugin') && <OfficialPluginBanner />}
    </div>
  );
}
